import { createSlice } from '@reduxjs/toolkit';

const initialSalesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  saleForView: undefined,
  error: null,
  msg: null,
};
export const callTypes = {
  list: 'list',
  action: 'action',
};

export const salesSlice = createSlice({
  name: 'sales',
  initialState: initialSalesState,
  reducers: {
    catchError: (state, action) => {
      //state.error = `${action.type}: ${action.payload.error}`;
      state.error = `${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    sendMsg: (state, action) => {
      state.msg = `${action.payload.msg}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.msg = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findSales
    salesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.msg = null;
      state.entities = entities;
      state.totalCount = totalCount;
      return state;
    },
    // getSaleById
    saleFetched: (state, action) => {
      state.actionsLoading = false;
      state.saleForView = action.payload.saleForView;
      state.error = null;
      state.msg = null;
      return state;
    },
    // create sale
    saleCreated: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.saleForView = action.payload.saleForView;
      return state;
    },

    // update Sale
    saleUpdated: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.saleForView = action.payload.saleForView;
      return state;
    },
    // delete sale
    saleDeleted: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
      return state;
    },
    // create sale
    saleCleared: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.saleForView = null;
      return state;
    },
  },
});
